import React, { useEffect, useState } from 'react';
import Loader from 'cccisd-loader';
import { getSupervisorCoaches } from '../../helpers/helpers';
import { SecureMessagingSupervision } from 'cccisd-laravel-secure-messaging';

function TfhMessagingSupervisor() {
    const [coachList, setCoachList] = useState(null);

    useEffect(() => {
        async function getCoaches() {
            const coaches = await getSupervisorCoaches();
            setCoachList(coaches);
        }

        getCoaches();
    }, []);

    if (coachList === null) {
        return <Loader loading />;
    }

    if (coachList.length === 0) {
        return (
            <div className="alert alert-info">
                <p className="mb-0">You are not currently assigned to supervise any Coaches. No messages to display.</p>
            </div>
        );
    }

    return <SecureMessagingSupervision participantIds={coachList.map(c => c.pawnId)} />;
}

export default TfhMessagingSupervisor;
